import React from "react";
import "./Loader.scss";

const Loader = () => {
  return (
    <div class="loader1">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default Loader;
